import { render, staticRenderFns } from "./HomePageContent.vue?vue&type=template&id=2b19d28b&scoped=true&"
import script from "./HomePageContent.vue?vue&type=script&lang=js&"
export * from "./HomePageContent.vue?vue&type=script&lang=js&"
import style0 from "./HomePageContent.vue?vue&type=style&index=0&id=2b19d28b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b19d28b",
  null
  
)

export default component.exports